import { useEffect, useState } from "react";
import { Column, GridView, Griew, Response } from "react-griew";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import RoleService from "../../service/role-service";
import Pasoonate from "pasoonate";
import CreateRoleWindow from "./CreateRoleWindow";
import EditRoleWindow from "./EditRoleWindow";
import RolePermissionsWindow from "./RolePermissionsWindow";
import RolePoliciesWindow from "./RolePoliciesWindow";

const roleService = new RoleService();
const griew = new Griew();

loadDictionary('role-main-page');

function RoleMainPage() {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenCreateWindow, setIsOpenCreateWindow] = useState(false);
  const [isOpenEditWindow, setIsOpenEditWindow] = useState(false);
  const [isOpenPermissionWindow, setIsOpenPermissionWindow] = useState(false);
  const [isOpenPolicyWindow, setIsOpenPolicyWindow] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  
  const reloadList = () => { 
    setIsLoading(true); 
    griew.refresh();
  };

  const handleOpenCreateWindow = () => {
    setIsOpenCreateWindow(true);  
  };

  const handleCloseCreateWindow = () => {
    setIsOpenCreateWindow(false);
    reloadList();
  };

  const handleOpenEditWindow = (roleId) => {
    setSelectedRoleId(roleId);
    setIsOpenEditWindow(true);  
  };

  const handleCloseEditWindow = () => {
    setSelectedRoleId(null);
    setIsOpenEditWindow(false);
    reloadList();
  };

  const handleOpenPermissionWindow = (roleId) => {
    setSelectedRoleId(roleId);
    setIsOpenPermissionWindow(true);  
  };

  const handleClosePermissionWindow = () => {
    setSelectedRoleId(null);
    setIsOpenPermissionWindow(false);  
  };

  const handleOpenPolicyWindow = (roleId) => {
    setSelectedRoleId(roleId);
    setIsOpenPolicyWindow(true);  
  };

  const handleClosePolicyWindow = () => {
    setSelectedRoleId(null);
    setIsOpenPolicyWindow(false);  
  };

  useEffect(() => {
    prepareGriew(setCount, setIsLoading, handleOpenEditWindow, handleOpenPermissionWindow, handleOpenPolicyWindow);
    // eslint-disable-next-line react-hooks/set-state-in-effect
    reloadList();
  }, []);

  return (
    <div className="page">
      <div className="page-header bg-body p-3">
        <h4 className="page-title">{i18n.t("role-main-page.page_title")}</h4>
        <div className="header-content"></div>
      </div>
      <div className="content-area bg-body-tertiary p-3">
        <div className="row mb-2">
          <div className="table-title col">
            <h5 className="mt-1 mb-3">{i18n.t("role-main-page.table_title")} ({count})</h5>
          </div>
          <div className="table-toolbar col-auto">
            <button className="btn btn-sm btn-primary me-2 mb-2" type="button" onClick={handleOpenCreateWindow}>{i18n.t("role-main-page.new_button")}</button>
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'rotate' : '')} type="button" onClick={reloadList}><i className="bi bi-arrow-clockwise"></i></button>
          </div>
        </div>
        <div className="table-responsive">
          <GridView griew={griew} ></GridView>
        </div>
      </div>
      <CreateRoleWindow isOpenWindow={isOpenCreateWindow} onCloseWindow={handleCloseCreateWindow} />
      <EditRoleWindow key={`edit-${selectedRoleId}`} isOpenWindow={isOpenEditWindow} onCloseWindow={handleCloseEditWindow} roleId={selectedRoleId} />
      <RolePermissionsWindow key={`permission-${selectedRoleId}`} isOpenWindow={isOpenPermissionWindow} onCloseWindow={handleClosePermissionWindow} roleId={selectedRoleId} />
      <RolePoliciesWindow key={`policy-${selectedRoleId}`} isOpenWindow={isOpenPolicyWindow} onCloseWindow={handleClosePolicyWindow} roleId={selectedRoleId} />
    </div>
  );
}

const prepareGriew = (setCount, setIsLoading, handleOpenEditWindow, handleOpenPermissionWindow, handleOpenPolicyWindow) => {
  const list = [
    {
      name: "id",
      caption: "کد",
      schema: "َRole",
      type: Column.NUMBER,
      order: 1,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "role_id",
      caption: "کد نقش",
      schema: "َRole",
      type: Column.NUMBER,
      order: 1,
      sortable: false,
      filterable: false,
      visibility: false,
    },
    {
      name: "name",
      caption: "نام",
      schema: "Role",
      type: Column.STRING,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "created_at",
      caption: "تاریخ ایجاد",
      schema: "Role",
      type: Column.DATETIME,
      order: 5,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const createdAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yy/MM/dd HH:mm");
  
        return <span dir="ltr">{createdAt}</span>;
      },
    },
    {
      name: "",
      caption: "عملیات",
      schema: "",
      type: Column.STRING,
      order: 6,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value, role) => { 
        const editButton = role.deleted_at ? '' : <button type="button" className="btn btn-sm btn-light" onClick={() => { handleOpenEditWindow(role.id) }}>{i18n.t("role-main-page.edit_button")}</button>;
        const permissionButton = role.deleted_at ? '' : <button type="button" className="btn btn-sm btn-light ms-1" onClick={() => { handleOpenPermissionWindow(role.id) }}>{i18n.t("role-main-page.permission_button")}</button>;
        const policyButton = role.deleted_at ? '' : <button type="button" className="btn btn-sm btn-light ms-1" onClick={() => { handleOpenPolicyWindow(role.id) }}>{i18n.t("role-main-page.policy_button")}</button>;
        // const removeButton = role.deleted_at ? '' : <button type="button" className="btn btn-sm btn-light ms-1" onClick={() => { handleRemoveRole(role.id) }}>{i18n.t("role-main-page.remove_button")}</button>;

        return (
          <>
          {editButton}          
          {/* {removeButton} */}
          {permissionButton}
          {policyButton}
          </>
        );
      }
    }
  ];
  const callback = (promis) => {
    promis.then(response => {
      const pagination = response.pagination;
      const data = response.data;

      const res = Response.make({
        data: data,
        pagination: {
          currentPage: pagination?.currentPage ?? 1,
          lastPage: pagination?.lastPage ?? 1,
          perPage: pagination?.perPage ?? 15,
          total: pagination?.total ?? 1,
          from: pagination?.from ?? 1,
          to: pagination?.to ?? 1,
        }
      });

      griew.refresh(res);

      setCount(pagination.total);

      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
    });
  };

  griew.localization.locale = 'fa';
  griew.columns.fromArray(list);
  griew.providers.default = 'function';
  griew.providers.getProvider().options = {
      function: (query) => roleService.gridview(query),
      callback: callback
  };
};

export default RoleMainPage;